var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinShadow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.998 1.44153C7.55838 -0.0461628 10.7055 -0.0201603 13.2419 1.50964C15.7533 3.0706 17.2797 5.85646 17.2654 8.85325C17.207 11.8304 15.5703 14.6289 13.5244 16.7923C12.3436 18.0466 11.0226 19.1557 9.58849 20.0969C9.44079 20.1823 9.27901 20.2395 9.11112 20.2656C8.94953 20.2587 8.79217 20.211 8.65323 20.1267C6.46378 18.7124 4.54297 16.9071 2.9832 14.7976C1.67803 13.0368 0.936526 10.9094 0.859376 8.7044C0.857682 5.70185 2.43762 2.92922 4.998 1.44153ZM6.47737 9.94745C6.90806 11.0092 7.92465 11.7018 9.05249 11.7018C9.79136 11.7071 10.5016 11.4112 11.025 10.8799C11.5484 10.3486 11.8414 9.62619 11.8388 8.87354C11.8427 7.7247 11.1664 6.68674 10.1255 6.24432C9.08468 5.80189 7.88465 6.04226 7.08575 6.85319C6.28685 7.66412 6.04668 8.88566 6.47737 9.94745Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.0625 23.7812C12.2985 23.7812 14.9219 23.2566 14.9219 22.6094C14.9219 21.9622 12.2985 21.4375 9.0625 21.4375C5.82646 21.4375 3.20312 21.9622 3.20312 22.6094C3.20312 23.2566 5.82646 23.7812 9.0625 23.7812Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinShadow);
export default __webpack_public_path__ + "static/media/location-pin-shadow.2cc2e5db1b7ac2c398cc6ff95c30a5fa.svg";
export { ForwardRef as ReactComponent };